import { useEffect } from 'react';
import Cookies from "js-cookie";
import pixel from './service/pixel';

const TrackPurchase  = ({ eventName, price, eventOrganisateurId }) => {
  useEffect(() => {
    const pixelOwnerId = Cookies.get("pixelOwnerId");
    // const pixelOwnerId = Cookies.get("pixelOwnerId");
    // const pixelOwnerId = getCookie('pixelOwnerId');

    /* if (!pixelOwnerId || pixelOwnerId !== eventOrganisateurId) {
      console.log("❌ AddToCart ignoré : organisateur ≠ pixel actif");
      return;
    } */
    console.log("❌ AddToCart ignoré : organisateur ≠ pixel actif");
    pixel.track('Purchase', {
      content_name: eventName,
      value: price,
      currency: 'EUR',
    });
  }, [eventName, price, eventOrganisateurId]);

  return null;
};

export default TrackPurchase ;